// Only show the spinner if loading takes longer than this, so cached responses don't flash it
const LOADING_DELAY_MS = 150;

type PickerLoadingElements = {
  form: HTMLElement;
  overlay: HTMLElement;
  updateButton: HTMLButtonElement;
};

/**
 * Loading state for one picker form: covers it with a spinner and stops Update submitting stale choices.
 * The returned start() begins loading and gives back a stop function; starting again takes over from an earlier
 * load, so an older request finishing late can't clear a newer one.
 */
export function createPickerLoading({
  form,
  overlay,
  updateButton,
}: PickerLoadingElements) {
  let activeStop: (() => void) | undefined;

  return function start() {
    activeStop?.();

    form.setAttribute("aria-busy", "true");
    updateButton.disabled = true;

    const timer = window.setTimeout(() => {
      overlay.classList.remove("tw:hidden");
      overlay.classList.add("tw:flex");
    }, LOADING_DELAY_MS);

    const stop = () => {
      window.clearTimeout(timer);
      if (activeStop !== stop) return;
      activeStop = undefined;
      form.removeAttribute("aria-busy");
      updateButton.disabled = false;
      overlay.classList.add("tw:hidden");
      overlay.classList.remove("tw:flex");
    };

    activeStop = stop;
    return stop;
  };
}
